import { Directive, OnInit, Renderer2, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appResizableColumn]',
  standalone: true,
})
export class ResizableColumnDirective implements OnInit {
  @Input('appResizableColumn') resizable!: boolean;
  @Input() index!: number;
  @Input() minWidth!: number;

  private startX!: number;
  private startWidth!: number;
  private pressed = false;
  private readonly column: HTMLElement;
  private table!: HTMLElement;

  constructor(
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
  ) {
    this.column = this.el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.resizable) return;

    const row = this.renderer.parentNode(this.column);
    const thead = this.renderer.parentNode(row);
    this.table = this.renderer.parentNode(thead);

    const resizer = this.renderer.createElement('span');
    this.renderer.addClass(resizer, 'resize-holder');
    this.renderer.appendChild(this.column, resizer);

    this.renderer.listen(resizer, 'mousedown', this.onMouseDown);
    this.renderer.listen(this.table, 'mousemove', this.onMouseMove);
    this.renderer.listen('document', 'mouseup', this.onMouseUp);
  }

  onMouseDown = (event: MouseEvent) => {
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = this.column.offsetWidth;
  };

  onMouseMove = (event: MouseEvent) => {
    if (!this.pressed || !event.buttons) return;

    this.renderer.addClass(this.table, 'resizing');
    const newWidth = this.startWidth + (event.pageX - this.startX);

    if (newWidth <= 50) return;

    // ヘッダーの幅を更新
    this.renderer.setStyle(this.column, 'width', `${newWidth}px`);
    this.renderer.setStyle(this.column, 'min-width', `${newWidth}px`);
    this.renderer.setStyle(this.column, 'max-width', `${newWidth}px`);

    // 対応する列（各行の該当セル）も更新
    const bodyRows = this.table.querySelectorAll('tbody tr');
    bodyRows.forEach((row: Element) => {
      const cell = row.children.item(this.index) as HTMLElement;
      if (cell) {
        this.renderer.setStyle(cell, 'width', `${newWidth}px`);
        this.renderer.setStyle(cell, 'max-width', `${newWidth}px`);
      }
    });
  };

  onMouseUp = () => {
    if (this.pressed) {
      this.pressed = false;
      this.renderer.removeClass(this.table, 'resizing');
    }
  };
}
